import React from 'react';
import { componentVariants, FORM_CONFIG } from '../../config';

const Input = ({ 
  id, 
  label, 
  type = FORM_CONFIG.INPUT_TYPES.TEXT, 
  placeholder, 
  value, 
  onChange, 
  error, 
  required = false,
  className = '',
  ...props 
}) => {
  const { base, error: errorClass, label: labelClass, errorText, required: requiredClass } = componentVariants.input;

  return (
    <div className="mb-4">
      <label htmlFor={id} className={labelClass}>
        {label}
        {required && <span className={requiredClass}>*</span>}
      </label>
      <input
        type={type}
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={`${base} ${error ? errorClass : ''} ${className}`}
        {...props}
      />
      {error && (
        <p className={errorText} role="alert">
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
